import { buildFieldSurfaceStyleFromKiot, type FieldSurfaceDefaults, type FieldSurfaceStyle } from './types'

/**
 * Base ô nhập trên màn POS `/admin/ban-hang`.
 * Tách hẳn khỏi `form` (modal admin) — chỉnh file này khi cần style POS.
 */
const base = buildFieldSurfaceStyleFromKiot()

export const POS_FIELD_SURFACE_STYLE: FieldSurfaceStyle = {
  ...base,
  /** Label — đồng bộ chuẩn Bán giao hàng (`posUnderline`). */
  labelFontSizePx: 15,
  labelFontWeight: 500,
  inputFontSizePx: 15,
  inputFontWeight: 500,
  /** Ô POS thấp/vuông hơn form modal (radius 8). */
  inputHeightPx: 38,
  borderRadiusPx: 4,
  inputPaddingX: 10,
  borderColor: '#d0d0d0',
  borderHover: '#b8b8b8',
  focusColor: '#0070f4',
  focusShadow: '0 0 0 1px rgba(0, 112, 244, 0.22)',
  labelGapPx: 2,
  inputBg: '#ffffff',
}

export const POS_FIELD_SURFACE_DEFAULTS: FieldSurfaceDefaults = {
  labelLayout: 'above',
  size: 'small',
  variant: 'outlined',
  fullWidth: true,
}
